export const formatCourtRoomLabel = (courtRoom: any) => {
  if (!courtRoom) return "";

  if (typeof courtRoom !== "object") {
    return String(courtRoom);
  }

  return (
    [courtRoom.roomNumber, courtRoom.courtRoomName].filter(Boolean).join(" - ") ||
    courtRoom.roomNumber ||
    courtRoom.courtRoomName ||
    ""
  );
};

export const getCauseCourtRoomLabel = (cause: any) => {
  if (cause?.courtType === "High Court") {
    return cause?.courtRoomNo || "N/A";
  }

  return (
    formatCourtRoomLabel(cause?.courtRoom) ||
    cause?.courtRoomNo ||
    cause?.courtRoom ||
    "N/A"
  );
};

export const getCauseCourtSelectionLabels = (cause: any) => ({
  highcourt: cause?.highcourt?.highCourtName,
  state:
    cause?.state ||
    cause?.district?.stateName ||
    cause?.courtRoom?.district?.stateName,
  bench: cause?.bench?.benchName,
  benchRoom: cause?.benchRoom?.benchName || cause?.courtRoomNo,
  district:
    cause?.district?.districtName || cause?.courtRoom?.district?.districtName,
  complex:
    cause?.complex?.complexName || cause?.courtRoom?.complex?.complexName,
  establishment:
    cause?.establishment?.name || cause?.courtRoom?.establishment?.name,
  courtRoom: formatCourtRoomLabel(cause?.courtRoom),
});
